import React from 'react';
import './speakers.scss';
import { translate } from "react-translate";
import { Row, Col } from 'react-bootstrap';

import tkachev from '../../../images/tkachev.jpg';
import abramov from '../../../images/abramov.jpg';
import novosilska from '../../../images/novosilska.jpg';
import kvanchakhadze from '../../../images/kvanchakhadze.jpg';
import makharashvili from '../../../images/makharashvili.jpg';
import papaskiri from '../../../images/papaskiri.jpg';
import dogozashvili from '../../../images/doghozashvili.jpg';
import sichenkov from '../../../images/sichenkov.jpg';
import inashvili from '../../../images/inashvili.jpg';
import barbakadze from '../../../images/barbakadze.jpg';
import lortkipanidze from '../../../images/lortkipanidze.jpg';
import fedorov from '../../../images/fedorov.jpg';
import khositashvili from '../../../images/khositashvili.jpg';
import barnov from '../../../images/barnov.jpg';
import barunova from '../../../images/barunova.jpg';
import pulatova from '../../../images/pulatova.jpg';
import baranova from '../../../images/baranova.jpg';
import todua from '../../../images/todua.jpg';
import marghishvili from '../../../images/marghishvili.jpg';


class Speakers extends React.Component {

  speakers = {
    tkachev: {
      ka: {
        name: 'ვლადისლავ ტკაჩოვი',
        work: (
          <div>
            <p>ექიმი ენდოკრინოლოგი, დერმატოლოგი, რუსეთის ხალხთა მეგობრობის უნივერსიტეტის "სამედიცინო ტრიქოლოგიის" კურსის ხელმძღვანელი.</p>
            <p>ჟურნალის "ტრიქოლოგია" მთავარი რედაქტორი.</p>
          </div>
        ),
        city: 'მოსკოვი'
      },
      en: {
        name: 'Vladislav Tkachev',
        work: (
          <div>
            <p>endocrinologist, dermatologist, head of the course “Medical Trichology” at RUDN University.</p>
            <p>Editor-in-chief of the journal Trichology.</p>
          </div>
        ),
        city: 'Moscow'
      },
      ru: {
        name: 'Владислав Петрович Ткачев',
        work: (
          <div>
            <p>врач-эндокринолог, дерматолог, руководитель курса «Медицинская Трихология» при РУДН.</p>
            <p>Главный редактор журнала «Трихология».</p>
          </div>
        ),
        city: 'Москва'
      }
    },

    abramov: {
      ka: {
        name: 'გიორგი აბრამოვი',
        work: 'ექიმი დერმატოლოგი, ტრიქოლოგი',
        city: 'მოსკოვი'
      },
      en: {
        name: 'George Abramov',
        work: 'dermatovenerologist, trichologist',
        city: 'Moscow'
      },
      ru: {
        name: 'Георгий Борисович Абрамов',
        work: 'дерматовенеролог, трихолог',
        city: 'Москва'
      }
    },

    novosilska: {
      ka: {
        name: 'მიროსლავა ნოვოსილსკა',
        work: (
          <div>
            <p>"ესთეთიკური მედიცინის კლინიკის" დამფუძნებელი</p>
            <p>მედიცინის მეცნიერებათა კანდიდატი, ექიმი ონკოდერმატოლოგი, ტრიქოლოგი-ტრანსპლანტოლოგი.</p>
            <p>ესთეტიკური მედიცინისა და ასაკის საწინააღმდეგო პოლონური ასოციაციის წევრი.</p>
            <p>უკრაინის თმის აღდგენის ასოციაციის ხელმძღვანელი.</p>
          </div>
        ),
        city: 'ლვოვი'
      },
      en: {
        name: 'Miroslava Novosilska',
        work: (
          <div>
            <p>Founder of the Clinic for Aesthetic Medicine</p>
            <p>doctor oncologist - dermatologist, trichologist, transplantologist.</p>
            <p>Member of the Polish Association of Aesthetic Medicine and Anti Age.</p>
            <p>Head of the All-Ukrainian Association of Hair Restoration.</p>
          </div>
        ),
        city: 'Lviv'
      },
      ru: {
        name: 'Мирослава Новосельская',
        work: (
          <div>
            <p>Основатель Клиники Эстетической Медицины</p>
            <p>Врач - онкодерматолог, трихолог, трансплантолог.</p>
            <p>Член Польской Асоциации Медицини Естетической и Анти Айджингу.</p>
            <p>Глава Всеукраинского обединения востановления волос.</p>
          </div>
        ),
        city: 'Львов'
      }
    },

    kvanchakhadze: {
      ka: {
        name: 'რუსუდან კვანჭახაძე',
        work: 'ექიმი ენდოკრინოლოგი, მედიცინის მეცნიერებათა დოქტორი, პროფესორი. საქართველოს პრევენციული მედიცინის აკადემიის წევრი.',
        city: 'თბილისი'
      },
      en: {
        name: 'Rusudan Kvanchakhadze',
        work: 'Endocrinologist',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Русудан Кванчахадзе',
        work: 'Врач-эндокринолог. Профессор, Член Академии превенционной медицины Грузии',
        city: 'Тбилиси'
      }
    },

    makharashvili: {
      ka: {
        name: 'ალექსი მახარაშვილი',
        work: (
          <div>
            <p><strong>ალექსი მახარაშვილი - პლასტიკური ქირურგი, პროფესორი. კლინიკა "დეამედის" სამედიცინო საქმიანობის ხარისხის კონტროლის და სამეცნიერო მიმართულების ხელმძღვანელი. GSHR-ს პრეზიდენტი.</strong></p>
            <p>თბილისის სახელმწიფო სამედიცინო უნივერსიტეტის საკვალიფიკაციო პროგრამის ხელმძღვანელი სპეციალობაში "თმის აუტოტრანსპლანტაცია".</p>
            <p>თმის აღდგენითი ქირურგიის საერთაშორისო საზოგადოების (ISHRS) (აშშ) წევრი.</p>
            <p>საქართველოს პლასტიკური, რეკონსტრუქციული და ესთეტიკური ქირურგიის საზოგადოების - GeoPRAS წევრი.</p>
            <p>რუსეთის ქირურგთა საზოგადოების წევრი.</p>
          </div>
        ),
        city: 'თბილისი'
      },
      en: {
        name: 'Aleksiy Makharashvili',
        work: (
          <div>
            <p><strong>Aleksiy Makharashvili – Surgeon, Doctor of Medicine, Professor. Head of medical service quality control of clinic “DeaMed”.</strong></p>
            <p>Qualification program coordinator in “Hair Autotransplantation” at Tbilisi State Medical University.</p>
            <p>Current member of The International Society of Hair Restoration Surgery. (ISHRS).</p>
            <p>The founder of The Association of Hair Transplantation and Trichology.</p>
            <p>Current member of Plastic, Reconstruction and Esthetic Surgery of Georgia (GeoPRAS).</p>
            <p>Current member of Society of Plastic Surgeons of Russia.</p>
          </div>
        ),
        city: 'Tbilisi'
      },
      ru: {
        name: 'Алексий Махарашвили',
        work: (
          <div>
            <p>Пластический хирург, доктор медицинских наук, профессор, президент «Грузинского общества восстановления волос» - GSHR.</p>
            <p>Руководитель квалификационной программы Тбилисского Государственного Медицинского Университета по специальности аутотрансплантация волос.</p>
            <p>Член «Международного общества хирургического восстановления волос» - ISHRS, США.</p>
            <p>Член «Общества пластической, реконструктивной и эстетической хирургии» GeoPRAS, Грузия.</p>
            <p>Член Российского общества хирургов.</p>
          </div>
        ),
        city: 'Тбилиси'
      }
    },

    papaskiri: {
      ka: {
        name: 'დეა პაპასკირი',
        work: (
          <div>
            <p><strong>დეა (დიანა) პაპასკირი - პლასტიკური ქირურგი, მედიცინის დოქტორი, კლინიკა "დეამედის" დამფუძნებელი და დირექტორი.</strong></p>
            <p>თმის აღდგენითი ქირურგიის საერთაშორისო საზოგადოების(ISHRS) წევრი (აშშ).</p>
            <p>საქართველოს პლასტიკური, რეკონსტრუქციული და ესთეტიკური ქირურგიის საზოგადოების (GeoPRAS) წევრი.</p>
            <p>რუსეთის პლასტიკური, რეკონსტრუქციული და ესთეტიკური ქირურგიის საზოგადოების წევრი.</p>
          </div>
        ),
        city: 'თბილისი'
      },
      en: {
        name: 'Dea Papaskiri',
        work: (
          <div>
            <p><strong>The founder and director of clinic “DeaMed”, Doctor of Medicine – Dea (Diana) Papaskiri.</strong></p>
            <p>Current member of The International Society of Hair Restoration Surgery. (ISHRS USA).</p>
            <p>Current member of the Society of Plastic, Reconstruction and Esthetic Surgery of Georgia.</p>
            <p>Current member of the Society of Plastic and Reconstruction Surgery of Russia.</p>
          </div>
        ),
        city: 'Tbilisi'
      },
      ru: {
        name: 'Деа Папаскири',
        work: (
          <div>
            <p><strong>Доктор медицинских наук, основатель и директор клиники «Деамед».</strong></p>
            <p>Действующий член  Международного общества хирургического  восстановления волос (ISHRS) (США).</p>
            <p>Действующий член общества пластической, реконструктивной и эстетической хирургии Грузии.</p>
            <p>Действующий член Общества пластических хирургов России.</p>
          </div>
        ),
        city: 'Тбилиси'
      },
    },

    sichenkov: {
      ka: {
        name: 'იური სიჩენკოვი',
        work: 'ანესთეზიოლოგ-რეანიმატოლოგი, მედიცინის მეცნიერებათა კანდიდატი, რუსეთის ფედერაციის ცენტრალური კლინიკური საავადმყოფოს ექიმი.',
        city: 'მოსკოვი'
      },
      en: {
        name: 'Iuri Sychenkov',
        work: 'Anesthesiologist - resuscitator, Central Clinical Hospital with a clinic of the Office of the President of the Russian Federation.',
        city: 'Moscow'
      },
      ru: {
        name: 'Юрий Гаврилович Сыченков',
        work: 'КМН, Анестезиолог - реаниматолог, ЦКБ с поликлиникой Управления делами Президента РФ.',
        city: 'Москва'
      }
    },

    dogozashvili: {
      ka: {
        name: 'მაკა დოღოზაშვილი',
        work: 'ექიმი დერმატოლოგი, ტრიქოლოგი',
        city: 'თბილისი'
      },
      en: {
        name: 'Maka Doghozashvili',
        work: 'Doctor, dermatologist-cosmetologist, trichologist',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Мака Догозашвили',
        work: 'Врач-дерматолог, трихолог',
        city: 'Тбилиси'
      }
    },

    inashvili: {
      ka: {
        name: 'ეკატერინა ინაშვილი',
        work: 'ექიმი ენდოკრინოლოგი, ნუცრიციოლოგი',
        city: 'თბილისი'
      },
      en: {
        name: 'Ekaterina Inashvili',
        work: 'Endocrinologist, Nutritionist',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Экатерина Инашвили',
        work: 'Врач-эндокринолог, нутрициолог',
        city: 'Тбилиси'
      }
    },


    barbakadze: {
      ka: {
        name: 'თამარ ბარბაქაძე',
        work: 'ექიმი მეან-გინეკოლოგი, რეპროდუქტოლოგი, ენდოკრინოლოგი',
        city: 'თბილისი'
      },
      en: {
        name: 'Tamar Barbakadze',
        work: 'Doctor, MD OB/GYN Reproductive Endocrinologist',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Тамар Барбакадзе',
        work: 'Доктор, акушер-гинеколог, репродуктолог, ендокринолог',
        city: 'Тбилиси'
      }
    },

    lortkipanidze: {
      ka: {
        name: 'ნინო ლორთქიფანიძე',
        work: (
          <div>
            <p>"საქართველოს თმის კვლევის საზოგადოების" პრეზიდენტი.</p>
            <p>"თმის და ფრჩხილების ს/დ დეპარტამენტის" ხელმძღვანელი კანისა და ვენსნეულებათა ს/კ ეროვნულ ცენტრში.</p>
            <p>დ. ტვილდიანის სამედიცინო უნივერსიტეტის ასოცირებული პროფესორი.</p>
            <p>აღმოსავლეთ ევროპის და აზიის თმის კვლევის საზოგადოების- პრეზიდენტი(EEAHRS).</p>
          </div>
        ),
        city: 'თბილისი'
      },
      en: {
        name: 'Nino Lortkipanidze',
        work: (
          <div>
            <p>President of Georgian Hair Research Society.</p>
            <p>Head of Department 'Hair and Nail' S/R Dermatology and Venereology National Center.</p>
            <p>Associate Professor at David Tvildiani Medical University.</p>
            <p>President of Eastern Europe and Asia Hair Research Society (EEAHRS).</p>
          </div>
        ),
        city: 'Tbilisi'
      },
      ru: {
        name: 'Нино Лорткипанидзе',
        work: (
          <div>
            <p>Президент “Грузинского Общесто Исследования  Волос“.</p>
            <p>Заведующий отделением  „Волос и Ногтей“- Национального Центра Кожных и Венерических заболеваний.</p>
            <p>Ассоцированный профессор Медицинского университета имени Д. Твилдиани.</p>
            <p>Президент Сообщества Исследования Волос Восточной Европы и Азии( EEAHRS).</p>
          </div>
        ),
        city: 'Тбилиси'
      }
    },

    fedorov: {
      ka: {
        name: 'სერგეი ფიოდოროვი',
        work: 'ქირურგი, კლინიკის Volosy.ru- ს დამფუძნებელი, თმის გადანერგვის სფეროში მოღვაწეობს 1996 წლიდან. აკადემიკოს ი.პ. პავლოვის სახელობის ლენინგრადის პირველი სამედიცინო ინსტიტუტის კურსდამთავრებული, 1986 წლიდან პრაქტიკოსი ქირურგი; მე-40 რუსული ანტარქტიდის ექსპედიციის ქირურგი. თმის გადანერგვის საერთაშორისო ორგანიზაციის წევრი 2001 წლიდან. კლინიკა ВОЛОСЫ.СOM',
        city: 'სანქტ-პეტერბურგი'
      },
      en: {
        name: 'Sergey Fyodorov',
        work: 'The surgeon, the founder of the clinic Volosy.ru, has been engaged in hair transplantation since 1996. Graduate of the First Leningrad Medical Institute named after Academician I.P. Pavlov, a practicing surgeon since 1986; surgeon of the 40th Russian Antarctic expedition. Member of the International Hair Transplant Organization since 2001. Hair clinic.COM',
        city: 'St. Petersburg'
      },
      ru: {
        name: 'Федоров Сергей Васильевич',
        work: 'Хирург, основатель клиники Волосы.ру, с 1996 года занимается пересадкой волос. Выпускник Первого ленинградского медицинского института имени академика И. П. Павлова, практикующий хирург с 1986 года; хирург 40-й Российской антарктической экспедиции. Член Международной организации пересадки волос с 2001 года. Клиника ВОЛОСЫ.СOM',
        city: 'Санкт-Петербург'
      }
    },

    khositashvili: {
      ka: {
        name: 'ლევან ხოსიტაშვილი',
        work: 'მეცნიერებათა დოქტორი, ფარმაცევტი',
        city: 'თბილისი'
      },
      en: {
        name: 'Levan Khositashvili',
        work: 'Doctor of science, pharmacist',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Леван Хоситашвили',
        work: 'Доктор наук, фармацевт',
        city: 'Тбилиси'
      }
    },

    barnov: {
      ka: {
        name: 'ივან ბარანოვი',
        work: 'ექიმი ტრიქოლოგი, ტრანსპლანტოლოგი. თმის მკურნალობის და ტრანსპლანტაციის ცენტრის HairMed - ის ხემძღვანელი. ISHRS, EHRS, UHRS და უკრაინის ტრიქოლოგთა ასოციაციის UADV წევრი.',
        city: 'ქ. დნეპრი'
      },
      en: {
        name: 'Ivan Baranov',
        work: 'Doctor trichologist, Transplantologist. Head of the Medical Treatment and Hair Transplantation Center “HairMed”. ISHRS, EHRS, UHRS, UADV, member of the Trichology Association Ukraine.',
        city: 'Dnipro'
      },
      ru: {
        name: 'Иван Викторович Баранов',
        work: 'Врач-трихолог, трансплантолог волос, хирург. Руководитель центра лечения и трансплантации волос HairMed. Член ISHRS, EHRS, UHRS, Всеукраинской ассоциации трихологов, UADV.',
        city: 'Днепр'
      }
    },

    barunova: {
      ka: {
        name: 'ნატალია ბარუნოვა',
        work: 'ექიმი, დერმატოლოგი, ტრიქოლოგი, დიეტოლოგი, ნუტრიციოლოგი, რეფლექსოთერაპევტი. ჟურნალ "ტრიქოლოგიის" რედაქტორი. "Skin Alliance"-ის (დერმატოლოგების და კოსმეტოლოგების ევროპის ალიანსი) წევრი. რუსეთის პროფესიონალ რეფლექსოთერაპევტთა ასოციაციის წევრი. ექიმებისათვის "სამედიცინო ტრიქოლოგიის პრაქტიკული ასპექტების" კურსის და სემინარის - "ტრიქოლოგიის, კოსმეტოლოგიისა და გამაახალგაზრდავებელი მედიცინის ნუტრიციოლოგიური ასპექტები"-ს ავტორი.',
        city: 'მოსკოვი'
      },
      en: {
        name: 'Natalia Barunova',
        work: 'Doctor, dermatologist, trichologist, dietologist, nutritionist, reflexotherapist. Editor of the newspaper “Trichology”. Member of the “Skin Alliance”. Member of the “Professional Association of Russian Reflexotherapists”. Author of the course “Practical Aspects of Medical Trichology”. Author of the seminar “Nutritional Aspects of Trichology, Cosmetology and Anti-age Medicine”.',
        city: 'Moscow'
      },
      ru: {
        name: 'Барунова Наталья Григорьевна',
        work: 'Врач дерматолог-трихолог, диетолог - нутрициолог, рефлексотерапевт, специалист по антивозрастной медицине. Научный редактор журнала «Трихология». Член Skin Alliance (Европейского альянса дерматологов и косметологов), Профессиональной Ассоциации Рефлексотерапевтов России. Автор курса для врачей «Практические аспекты медицинской трихологии» и семинара «Нутрициональные аспекты трихологии, косметологии и анти-эйдж медицины».',
        city: 'Москва'
      }
    },

    pulatova: {
      ka: {
        name: 'ჯამილია პულატოვა',
        work: 'ტრიქოლოგი - ტრანსპლანტოლოგი. ჯანსაღი თმის ცენტრის "TRIONICA"-ს დამფუძნებელი და ხემძღვანელი. ცენტრალური აზიის სერტიფიცირებული ტრენერი ტრიქოპიგმენტაციაში.',
        city: 'ტაშკენტი'
      },
      en: {
        name: 'Jamilia Pulatova',
        work: 'Trichologist, transplantologist. Founder and the Head of the Healthy Hair Center “TRIONICA”. Certified trainer of the Central Asia in Tricho Pigmentation.',
        city: 'Tashkent'
      },
      ru: {
        name: 'Пулатова Джамиля Каримкуловна',
        work: 'Трихолог-трансплантолог. Основатель и руководитель Центра здоровья волос "TRIONICA". Сертифицированный тренер по трихопигментации в Центральной Азии.',
        city: 'Ташкент'
      }
    },

    baranova: {
      ka: {
        name: 'ოლგა ბარანოვა',
        work: 'ტრიქოპიგმენტაციის სპეციალისტი',
        city: 'დნეპრი'
      },
      en: {
        name: 'Olga Baranova',
        work: 'Specialist at Tricho Pigmentation',
        city: 'Dnipro'
      },
      ru: {
        name: 'Ольга Баранова',
        work: 'Специалист по Трихопигментации',
        city: 'Днепр'
      }
    },

    todua: {
      ka: {
        name: 'კახაბერ თოდუა',
        work: 'ონკოქირურგი; კანის, რბილი ქსოვილების და ძვლების სიმსივნეების მიმართულების ხელმძღვანელი. ნიუ ვიჟენის საუნივერსიტეტო ჰოსპიტალი.',
        city: 'თბილისი'
      },
      en: {
        name: 'Kakhaber Todua',
        work: 'Oncologist, surgeon. Head of skin, soft tissue and bone tumors direction at the New Vision University Hospital.',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Кахабер Тодуа',
        work: 'Хирург-онколог; руководитель департамента опухолей кожи, мягких тканей и костей. Университетский госпиталь New Vision.',
        city: 'Тбилиси'
      }
    },

    marghishvili: {
      ka: {
        name: 'რამაზ მარღიშვილი',
        work: 'ექიმი. კომპანია Regen Lab SA (შვეიცარია) წამომადგენელი საქართველოში.',
        city: 'თბილისი'
      },
      en: {
        name: 'Ramaz Marghishvili',
        work: 'Doctor. Representative of the company Regen Lab SA (Switzerland) in Georgia.',
        city: 'Tbilisi'
      },
      ru: {
        name: 'Рамаз Маргишвили',
        work: 'Доктор.  Представитель  компании Regen Lab SA (Швейцария) в Грузии.',
        city: 'Тбилиси'
      }
    },
  };


  render() {
    return (
      <div className="component speakers">
        <div className="content">
          <h4 className="block_title capsFont">{ this.props.t('speakers') }</h4>
          <div className="grid">
            <Row>
              <Col lg={3}>&nbsp;</Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.makharashvili[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={makharashvili} alt="makharashvili" />
                        <p className="speaker_name capsFont">{ this.speakers.makharashvili[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.makharashvili[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={3}>&nbsp;</Col>
            </Row>
            <Row>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.lortkipanidze[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={lortkipanidze} alt="lortkipanidze" />
                        <p className="speaker_name capsFont">{ this.speakers.lortkipanidze[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.lortkipanidze[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={tkachev} alt="tkachev" />
                        <p className="speaker_name capsFont">{ this.speakers.tkachev[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.tkachev[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.tkachev[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.novosilska[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={novosilska} alt="novosilska" />
                        <p className="speaker_name capsFont">{ this.speakers.novosilska[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.novosilska[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={abramov} alt="abramov" />
                        <p className="speaker_name capsFont">{ this.speakers.abramov[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.abramov[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <p className="speaker_work bodyFont">{ this.speakers.abramov[this.props.commonProps.lang].work }</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <p className="speaker_work bodyFont">{ this.speakers.dogozashvili[this.props.commonProps.lang].work }</p>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={dogozashvili} alt="dogozashvili" />
                        <p className="speaker_name capsFont">{ this.speakers.dogozashvili[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.dogozashvili[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={kvanchakhadze} alt="kvanchakhadze" />
                        <p className="speaker_name capsFont">{ this.speakers.kvanchakhadze[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.kvanchakhadze[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <p className="speaker_work bodyFont">{ this.speakers.kvanchakhadze[this.props.commonProps.lang].work }</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.sichenkov[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={sichenkov} alt="sichenkov" />
                        <p className="speaker_name capsFont">{ this.speakers.sichenkov[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.sichenkov[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={papaskiri} alt="papaskiri" />
                        <p className="speaker_name capsFont">{ this.speakers.papaskiri[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.papaskiri[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.papaskiri[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.barbakadze[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={barbakadze} alt="barbakadze" />
                        <p className="speaker_name capsFont">{ this.speakers.barbakadze[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.barbakadze[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={inashvili} alt="inashvili" />
                        <p className="speaker_name capsFont">{ this.speakers.inashvili[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.inashvili[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.inashvili[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.fedorov[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={fedorov} alt="fedorov" />
                        <p className="speaker_name capsFont">{ this.speakers.fedorov[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.fedorov[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={khositashvili} alt="khositashvili" />
                        <p className="speaker_name capsFont">{ this.speakers.khositashvili[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.khositashvili[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.khositashvili[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.barnov[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={barnov} alt="barnov" />
                        <p className="speaker_name capsFont">{ this.speakers.barnov[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.barnov[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={barunova} alt="barunova" />
                        <p className="speaker_name capsFont">{ this.speakers.barunova[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.barunova[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.barunova[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.pulatova[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={pulatova} alt="pulatova" />
                        <p className="speaker_name capsFont">{ this.speakers.pulatova[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.pulatova[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={baranova} alt="baranova" />
                        <p className="speaker_name capsFont">{ this.speakers.baranova[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.baranova[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.baranova[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className="speaker_details left">
                          <div className="speaker_work bodyFont">
                            { this.speakers.todua[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                      <td className="speaker_photo" align="center">
                        <img src={todua} alt="todua" />
                        <p className="speaker_name capsFont">{ this.speakers.todua[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.todua[this.props.commonProps.lang].city }</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col lg={6}>
                <table>
                  <tbody>
                    <tr>
                      <td className="speaker_photo" align="center">
                        <img src={marghishvili} alt="marghishvili" />
                        <p className="speaker_name capsFont">{ this.speakers.marghishvili[this.props.commonProps.lang].name }</p>
                        <p className="speaker_city capsFont">{ this.speakers.marghishvili[this.props.commonProps.lang].city }</p>
                      </td>
                      <td>
                        <div className="speaker_details right">
                          <div className="speaker_work bodyFont">
                            { this.speakers.marghishvili[this.props.commonProps.lang].work }
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }

}

export default translate('Speakers')(Speakers);
